<template>
  <v-list dense>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Buy 1 Get X Free</v-list-item-title>
        <v-list-item-subtitle>Free Quantity: {{ promoItem.quantity }}</v-list-item-subtitle>
        <!-- <v-list-item-subtitle>Stock ID: {{ promoItem.stockId }}</v-list-item-subtitle> -->
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'B1gx',
  props: {
    promoItem: { type: Object, required: true },
  },
}
</script>